import React, {useContext, useEffect} from "react";
import {useParams} from "react-router";
import {primary, secondary, theme} from "../style/globalStyle";
import {Context} from "../states/Store";
import {
    declineRegistration,
    verifyRegistrationKey
} from "../services/RegistrationService";
import {
    Button,
    Grid,
    Typography
} from "@mui/material";
import RegistrationContainer from "../components/common/RegistrationContainer";
import i18next from "i18next";
import {useStyles} from "../style/completeStyle";

// Composant pour décliner une invitation FO et ne plus être relancé
function Decline() {
    const classes = useStyles();
    const [, dispatch] = useContext(Context);
    const [isAlreadyUsedToken, setIsAlreadyUsedToken] = React.useState(false);
    const [isTokenValidAndFounded, setIsTokenValidAndFounded] = React.useState(false);
    const [isUserValidDecline, setIsUserValidDecline] = React.useState(false);
    let {registrationKey} = useParams();

    useEffect(() => {
        let link = document.querySelector("link[rel~='icon']");
        theme.palette.primary.main = secondary
        theme.palette.secondary.main = primary
        link.href = process.env.PUBLIC_URL + "/favicon_fo.ico";

        let title = document.querySelector("title");
        title.textContent = "Aprovall";

        dispatch({type: "REGISTRATION_THEME", theme: "fo"});
    }, [dispatch])

    // Vérifie que le token est valide et n'est pas déja utilisé
    useEffect(() => {
        (async () => {
            try {
                dispatch({type: "LOADER", loader: true});
                console.log("before", registrationKey)
                const verificationResp = await verifyRegistrationKey(registrationKey);
                console.log("after", verificationResp)
                if (verificationResp.httpStatus !== "NOT_FOUND") {
                    setIsTokenValidAndFounded(true)
                    console.log("ok")
                }else if(verificationResp.httpStatus === "NOT_FOUND" && verificationResp.messages[0]?.text === 'registration token already used'){
                    setIsAlreadyUsedToken(true);
                    console.log("oups")
                }
            } catch (e) {
                console.log(e);
            }
            dispatch({type: "LOADER", loader: false});
        })();
    }, [registrationKey, dispatch]);

   // Enclenche la désinscription
   const handleValidateDecline = async () => {
       try {
           await declineRegistration(registrationKey);
           setIsUserValidDecline(true);
       } catch (e) {
           console.log(e);
       }
   }

    return (
        <RegistrationContainer app={"fo"} registrationTheme={"fo"}>
            <div className={classes.root}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    className="registrationHeader"
                >
                    <Typography variant="h1" classes={{root: "headerLabel"}}>
                        {i18next.t(
                            isAlreadyUsedToken ? "decline.requestHasAlreadyTaken.title"
                                : isTokenValidAndFounded && !isUserValidDecline ? "decline.confirmDecline.title"
                                : "decline.declineHasConfirmed.title"
                        )}
                    </Typography>

                    <div style={{ marginTop: "20px"}}>
                        {i18next.t(
                            isAlreadyUsedToken ? "decline.requestHasAlreadyTaken.EmailAlreadyDeleted"
                                : isTokenValidAndFounded && !isUserValidDecline ? "decline.confirmDecline.EmailDeleted"
                                    : "decline.declineHasConfirmed.EmailAlreadyDeleted"
                        )}
                        <br/>
                        {i18next.t(
                            isAlreadyUsedToken ? "decline.requestHasAlreadyTaken.noReceiveEmail"
                                : isTokenValidAndFounded && !isUserValidDecline ? "decline.confirmDecline.noReceiveEmail"
                                    : "decline.declineHasConfirmed.noReceiveEmail"
                        )}
                        <br/><br/>
                        {
                            isTokenValidAndFounded && !isUserValidDecline && (
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        onClick={handleValidateDecline}
                                    >
                                        {i18next.t("send")}
                                    </Button>
                                </div>

                            )
                        }
                    </div>
                </Grid>
            </div>
        </RegistrationContainer>
    )
}

export default Decline;
